import { get } from '@/lib/api-client';
import type { UserSkinsResponse, UserSkinTrialsResponse } from 'shared-types';

export const skinsApi = {
  getUserSkins: (): Promise<UserSkinsResponse> => get<UserSkinsResponse>('/skins'),
  getUserSkinTrials: (): Promise<UserSkinTrialsResponse> =>
    get<UserSkinTrialsResponse>('/skins/trials')
};
